export const loTrinh = {
  banDo: {
    title: 'Bản đồ giao hàng',
    subtitle: 'Đơn cần giao theo hạn giao hàng',
    filter: {
      hanGiao: 'Hạn giao hàng',
      hanGiaoTu: 'Từ',
      hanGiaoDen: 'Đến',
      loaiGiao: 'Hình thức giao',
      trangThai: 'Trạng thái đơn',
      search: 'Mã HĐ, khách, SĐT…',
      xem: 'Xem',
      loaiGiaoTatCa: 'Tất cả',
      loaiGiaoTuGiao: 'Tự giao',
      loaiGiaoHang: 'Hãng vận chuyển',
      tatCaTrangThai: 'Tất cả trạng thái',
      timKiem: 'Tìm kiếm',
      hinhThucTrangThai: 'Hình thức & trạng thái',
      sapXep: 'Sắp xếp',
      sapXepTheo: 'Sắp xếp theo',
      khoVatLy: 'Kho vật lý',
      khoVatLyTatCa: 'Tất cả kho vật lý',
      khoVatLyEmpty: 'Không có kho vật lý',
    },
    sapXep: {
      hanGiaoTang: 'Hạn giao sớm nhất',
      hanGiaoGiam: 'Hạn giao muộn nhất',
      canGiam: 'Nặng nhất',
      khoiGiam: 'Thể tích lớn nhất',
      kienGiam: 'Nhiều kiện nhất',
      maDon: 'Mã hóa đơn',
      khachHang: 'Tên khách (A–Z)',
    },
    preset: {
      den3hToi: 'Đến 3 giờ tới',
      homNay: 'Hôm nay',
      ngayMai: 'Ngày mai',
      homNayVaMai: 'Hôm nay và ngày mai',
      tuyChon: 'Tùy chọn',
    },
    nhomTrangThai: {
      moi: 'Mới',
      xuLyKho: 'Đang xử lý kho',
      dieuPhoi: 'Chờ / đang điều phối',
      giaoHang: 'Chờ / đang giao',
      giaoLai: 'Giao thất bại / giao lại',
    },
    thamSo: {
      title: 'Đang lọc',
      hanGiao: 'Hạn giao',
      loaiGiao: 'Hình thức',
      trangThai: 'Trạng thái',
      search: 'Từ khóa',
      mucHan: 'Mức hạn',
      khoVatLy: 'Kho vật lý',
      ketQua: '{don} đơn · {diem} điểm giao',
    },
    donVi: {
      kg: 'kg',
      kien: 'kiện',
      m3: 'm³',
      don: 'đơn',
    },
    nhan: {
      an: 'Chấm',
      anMo: 'Chỉ hiện chấm — rê chuột để xem nhãn',
      gon: 'Giờ',
      gonMo: 'Nhãn gọn: hạn giao',
      diaChi: 'Địa chỉ',
      diaChiMo: 'Tên khách + địa chỉ — hình dung đơn đi đâu',
      dayDu: 'Đầy đủ',
      dayDuMo: 'Hạn giao + tên + địa chỉ + cân / kiện / khối',
    },
    veBanDau: 'Về khung nhìn ban đầu',
    xoayBanDo: 'Xoay bản đồ 90° (đang xoay {n}°)',
    nen: {
      sang: 'Nền sáng',
      chiTiet: 'Nền chi tiết',
    },
    tongHop: {
      soDon: '{n} đơn',
      soDiem: '{n} điểm giao',
      tongKg: '{n} kg',
      tongM3: '{n} m³',
      tongKien: '{n} kiện',
      tongCod: 'COD {n}',
      nhanSoDon: 'Đơn hàng',
      nhanSoDiem: 'Điểm giao',
      nhanTongKg: 'Tổng cân (kg)',
      nhanTongKien: 'Tổng kiện',
      nhanTongM3: 'Tổng khối (m³)',
      nhanTongCod: 'Tổng COD',
      thieuToaDo: '{n} đơn thiếu toạ độ',
      biCatBot: 'Chỉ hiển thị {n} đơn đầu — thu hẹp khoảng thời gian',
    },
    chuGiai: {
      title: 'Hạn giao',
      tatCa: 'Tất cả',
      quaHan: 'Đã quá hạn',
      trong2h: 'Trong 2 giờ tới',
      homNay: 'Còn lại hôm nay',
      sauHomNay: 'Từ ngày mai',
      kho: 'Kho xuất phát',
    },
    list: {
      empty: 'Không có đơn nào trong khoảng hạn giao này',
      thieuToaDo: 'Chưa có toạ độ',
      hangVanChuyen: 'Hãng',
    },
    don: {
      khachHang: 'Khách hàng',
      nguoiNhan: 'Người nhận',
      diaChi: 'Địa chỉ',
      hanGiao: 'Hạn giao',
      khungGio: 'Khung giờ nhận',
      canKhoiKien: 'Cân / khối / kiện',
      kichThuoc: 'Kích thước kiện',
      tongTien: 'Tổng tiền',
      cod: 'COD',
      dichVu: 'Dịch vụ',
      doiTac: 'Giao bởi',
      uuTien: 'Ưu tiên',
      hangHoa: 'Hàng hóa',
      ghiChu: 'Ghi chú',
      xemChiTiet: 'Xem chi tiết đơn',
      themMatHang: '+{n} mặt hàng khác',
      soDonTaiDiem: '{n} đơn tại điểm này',
      quaHanPhut: 'Quá hạn {n}',
    },
    tab: {
      don: 'Danh sách đơn',
      loTrinh: 'Gợi ý lộ trình',
    },
    goiY: {
      khoXuatPhat: 'Kho xuất phát',
      gioXuatPhat: 'Giờ xuất phát',
      veKho: 'Xe quay về kho',
      xe: 'Xe tham gia',
      quanLyXe: 'Quản lý xe',
      chuaCoXe: 'Chưa có xe nào — bấm "Quản lý xe" để thêm',
      chonTatCa: 'Chọn tất cả',
      boChon: 'Bỏ chọn',
      soXe: '{n} xe',
      caLam: 'Ca',
      suaThongSo: 'Sửa',
      thuGon: 'Thu gọn',
      nut: 'Gợi ý lộ trình ({n} đơn)',
      dangTinh: 'Đang tính lộ trình…',
      boQuaHang: 'Bỏ qua {n} đơn giao qua hãng vận chuyển',
      khongCoDon: 'Không có đơn tự giao nào trong bộ lọc hiện tại',
      phuongAn: 'Phương án',
      mucTieu: {
        RE: 'Rẻ nhất',
        IT_XE: 'Ít xe nhất',
        NHANH: 'Nhanh nhất',
        KHU_VUC: 'Theo khu vực',
        CAN_BANG: 'Chia đều xe',
        TU_CHINH: 'Đã chỉnh tay',
      },
      cungKetQua: 'trùng với: {n}',
      canhBaoPa: '{n} chuyến cần xem lại',
      canhBao: {
        QUA_TAI_KG: 'Quá tải (kg)',
        QUA_TAI_M3: 'Quá thể tích',
        VUOT_SO_DIEM: 'Vượt số điểm',
        VUOT_CA: 'Vượt giờ ca',
      },
      chinh: {
        doiXe: 'Đổi xe cho chuyến này',
        doiSang: 'Đổi sang xe',
        doiCho: 'đổi chỗ với chuyến đang chạy',
        chuyenDon: 'Chuyển đơn {n} sang',
        chuyenMoi: 'chuyến mới',
        boRa: 'Bỏ ra khỏi chuyến',
        themVao: 'Thêm đơn {n} vào xe',
        meo: 'Bấm mã đơn để chuyển xe / bỏ ra',
        hoanTac: 'Hoàn tác',
        dangTinhLai: 'Đang tính lại…',
      },
      kpi: {
        km: 'Tổng km',
        thoiGian: 'Tổng thời gian',
        chiPhi: 'Chi phí ước tính',
        soXe: 'Số xe',
        donTre: 'Đơn trễ hạn',
        khongXep: 'Chưa xếp',
      },
      chuyen: {
        xuatPhat: 'Xuất phát {n}',
        ve: 'Về kho {n}',
        ketThuc: 'Xong {n}',
        tai: 'Tải',
        vuotCa: 'Vượt giờ ca',
        diem: '{n} điểm',
        xemTrenBanDo: 'Xem riêng chuyến này',
        hienTatCa: 'Hiện tất cả chuyến',
      },
      tre: 'Trễ',
      khongXepTitle: 'Đơn chưa xếp được',
      lyDo: {
        THIEU_TOA_DO: 'Thiếu toạ độ',
        VUOT_TAI: 'Vượt tải xe lớn nhất',
        KHONG_DU_XE: 'Không đủ xe / giờ ca',
        BO_RA: 'Chưa xếp xe',
      },
      thongKe:
        'Khoảng cách: {cache} cặp lấy từ bộ nhớ, {moi} cặp tính mới ({req} request), {uoc} cặp ước lượng · {ms} ms',
      nguon: {
        OSRM: 'Đường bộ thật (OSRM)',
        UOC_LUONG: 'Ước lượng đường chim bay — chưa bật OSRM',
        KET_HOP: 'Một phần ước lượng — OSRM chưa đủ dữ liệu',
      },
      solver: {
        VROOM: 'VROOM',
        NOI_BO: 'Solver nội bộ',
      },
      lamMoi: 'Tính lại',
      dong: 'Đóng kết quả',
      phut: '{n} phút',
      gioPhut: '{h} giờ {m} phút',
    },
    xe: {
      title: 'Xe giao hàng',
      them: 'Thêm xe',
      sua: 'Sửa xe',
      xoa: 'Xóa xe',
      xacNhanXoa: 'Xóa xe "{n}"?',
      daLuu: 'Đã lưu xe',
      daXoa: 'Đã xóa xe',
      ten: 'Tên xe',
      bienSo: 'Biển số',
      loaiXe: 'Loại xe',
      taiTrongKg: 'Tải trọng (kg)',
      theTichM3: 'Thể tích thùng (m³)',
      theTichMo: 'Bỏ trống = không giới hạn',
      soDiemToiDa: 'Số điểm tối đa / chuyến',
      gioBatDau: 'Bắt đầu ca',
      gioKetThuc: 'Về kho trước',
      phiCoDinh: 'Phí cố định / chuyến',
      phiMoiKm: 'Phí / km',
      phiMoiGio: 'Phí / giờ',
      phiMo: 'Dùng để so sánh phương án — bỏ trống dùng mặc định 5.000đ/km, 50.000đ/giờ',
      kho: 'Kho xuất phát mặc định',
      khoTheoForm: 'Theo kho chọn khi gợi ý',
      tenTaiXe: 'Tài xế',
      dienThoaiTaiXe: 'SĐT tài xế',
      ghiChu: 'Ghi chú',
      dangHoatDong: 'Đang hoạt động',
      ngungHoatDong: 'Ngừng hoạt động',
      trong: 'Chưa có xe nào',
      luu: 'Lưu',
      huy: 'Hủy',
      batBuoc: 'Bắt buộc',
    },
  },
}
